<template>
    <div :class="'img-' + size" class="custom-icon">
        <svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path class="path" stroke="#0C2340" d="M2 20h30.958l13.86 63.924h65.785L126.463 20h-49.35"/><path d="M57 101.992a4 4 0 110 8 4 4 0 010-8zm46 0a4 4 0 110 8 4 4 0 010-8z" class="highlight" stroke="#00BBDC"/></g></svg>
    </div>
</template>

<script>
    export default {
        props: {
            size: {
                type: String,
                default: '4x'
            }
        }
    }
</script>